var _defs, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgBarGauche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 478 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_540",
    x1: 10.5,
    y1: 10.5,
    x2: 463.5,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0347ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3e2fe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d23d3",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar"
  }, /*#__PURE__*/React.createElement("image", {
    width: 478,
    height: 25,
    opacity: 0.64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAd4AAAAZCAYAAACfBE97AAAACXBIWXMAAAsSAAALEgHS3X78AAADAUlEQVR4Xu3dwU4bMRRG4TMQCmmhqPT9HxIopCEJ04V9M47jSRCLLvD5JCvDKBHLX/dee2YYxxFJkvR/LM59oWUYhuHcdyRJ+urGT1Svw7nfVCE7dy1JUm/KAN1fnwvj2eDNgRvhehG3iyVJUu/GYgG8x/25AG62movQvWisuA8GsCSpT2XQjvnzYA3D0Kx+jyreHLoRspd5LYp1yRTAtp4lSb2oW8sRuDtgW6xdXu/Aex2+BxVvVekugCvgW17X+fOKKZANXklSL+rgjYDdAG/AOn++5XtbYKwr37rVHKF7SQrYa+B7sZb53lX+rTNfSVJPypnulhSwa2AFvOYVmVhWxcfBW+xeLoN3CdwBP/O6JQVwhG+r5SxJ0ldVhmmE7ivwB3gi5WfZgo557xBV71zFu2Cqdu+AX8ADcJ//XpLaztFuNnglST2I4N2RWsor4Bl4ZArdet470Kp4swjRqHhvgB+kwH0AfufrqHrLdrMkSV9d2WaOandJys0dU9t5xUxx2jpOVM95b0hBe0tqN9/n65v8e48WSZJ6UB4h2gJ/STk5kgL3hZSNsQk5xrEHyuAdqlUeKYodzuUu529MwWvoSpJ6EPPbi/wZp31i03EEbrkHKtbRjHesVhwCjvNJG6Yt029M/9SKV5LUg7riLY8OxfGh/YYqjnMVaLeay91YG1IpHTu2rkkBu8EZrySpP60Z7xMpI19JmblhCuB94IY6eMvdWhG6L0y7tXakgbG7miVJPTq1q/mRlJll+B5Uu9AO3iihI8mjqo3QfcJzvJKkPpXj2NY53uf895qUpUdV7z54x3Ec80M0yjbziil010ztZp9cJUnqUTmznXty1YrDdvPJR0bW8924F21nn9UsSepVWblGu/nUs5qbc17fTiRJ0sfUwVsWqx9+O9FR8AK+j1eSpNMiPGffx0vqMB+FbDN44SB84TBonelKkpSUM1/IM11mQhdOBO/+C9Nbi8DWsiRJoW49p4szwXo2eFuqMJYkqUvnQrblU8ErSZI+5x9jwVl9KYKoiwAAAABJRU5ErkJggg==",
    style: {
      mixBlendMode: "multiply"
    }
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 10.5,
    x2: 463.5,
    y2: 10.5,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7,
    stroke: "url(#D\\xE9grad\\xE9_sans_nom_540)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBarGauche);
export default __webpack_public_path__ + "static/media/imgBarGauche.b8784b7846c6549626aa9fb3bd8fc752.svg";
export { ForwardRef as ReactComponent };